import styled from 'styled-components';
import Box from '@mui/material/Box';
import THEME from '../../../../../../constants/theme';

export const StyledBox = styled(Box)`
  display: flex;
  align-items: center;
`;

export const StyledWrapper = styled(StyledBox)`
  flex: 1;

  a {
    width: 100%;
    display: flex;
    margin-left: 24px;
    justify-content: space-between;
    align-items: center;

    &:hover {
      svg {
        path {
          stroke: ${THEME.primaryColors.primary};
        }
      }
    }
  }
`;

export const NotConnectedStyledBox = styled(StyledBox)`
  width: 100%;
  height: 64px;
  justify-content: space-between;
  padding: 12px 26px;
  background-color: ${THEME.primaryColors.orange};
`;

export const StyledPaymentsWrapper = styled(Box)`
  border-radius: 8px;
  overflow: hidden;
`;
